import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './FooterLink.module.scss'

interface FooterLinkProps {
  href: string
  children: React.ReactNode
  external?: boolean
}

export const FooterLink: React.FC<FooterLinkProps> = ({ href, children, external = false }) => {
  if (external) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>{children}</a>
  }

  return <Link href={href} className={styles.link}>{children}</Link>
}
